'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _profilesFilter = require('./profiles-filter.html');

var _profilesFilter2 = _interopRequireDefault(_profilesFilter);

var _profilesFilter3 = require('./profiles-filter.controller');

var _profilesFilter4 = _interopRequireDefault(_profilesFilter3);

require('./profiles-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var profilesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _profilesFilter2.default,
  controller: _profilesFilter4.default,
  controllerAs: 'vm'
};

exports.default = profilesFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/profiles-filter/profiles-filter.component.js
 **/